<template>
  <div class="page-container imitate-page ">
    <div class="imitate-home" >
      <trade-page :modalType="modalType"></trade-page>
    </div>

  </div>
</template>
<script>
import { Button, Tabs, Tab, Search } from 'vant'
import { imitateWallet } from '@/api/trade'
import { monetaryList } from '@/api/index'
import { optionReport } from '@/api/assest'
import tradePage from './trade'
export default {
  name: 'home',
  components: {
    Button,
    Tabs,
    Tab,
    Search,
    tradePage
  },
  data() {
    return {
      form: {
        keyword: ''
      },
      modalType: 1,
      tabIndex: 1,
      userType: 1,
      orderIndex: 0,
      
    }
  },
  watch: {
    $route() {
      let type = this.$route.query.imitateType
      this.modalType = type
    }
  },
  mounted() {
    let type = this.$route.query.imitateType
    this.modalType = type
  },
  methods: {
   
  }
}
</script>